var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-preview-list"},[_vm._l((_vm.blogs),function(blog){return _c('blog-preview',{attrs:{"blog":blog}})}),_c('pagination',{attrs:{"pageInfo":_vm.pageInfo},on:{"change":_vm.getPageBlogs}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }